import styled from 'styled-components';
import { Margin } from '../../../common/styles';
import { isMobile } from '../../../common/Helpers/useragent';

export const AccordionWrapper = styled.div`
  button {
    padding-right: 0 !important;
    margin-left: 0 !important;
    padding-bottom: 0rem !important;
  }
  [class^='AccordionWrapper-VDS'] {
    border-top: 1px solid !important;
  }
  [class^='StyledAccordionDetail-VDS'] {
    padding-bottom: 0.5rem !important;
  }
  [class^='StyledAccordionItem-VDS'] {
    padding-bottom: 0rem !important;
  }
`;

export const StlyedMargin = styled(Margin)`
  border-bottom: 2.5px solid !important;
`;

export const StyledSurcharge = styled.div`
  font-weight: bold;
  padding: 30px 0 20px 0;
  border-top: 1px solid !important;
  border-bottom: none !important;
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

export const StyledTaxes = styled.div`
  font-weight: bold;
  padding-top: 30px;
  border-top: 1px solid !important;
`;

export const FirstColumn = styled.div`
  width: ${isMobile() ? '48%' : '52%'};
`;
export const Subtext = styled.div`
  color: #747676;
`;

export const SecondColumn = styled.div`
  width: ${isMobile() ? '52%' : '48%'};
  @media screen and (max-width: 480px) {
    [class^='StyledTypography-'] {
      margin-top: 3.5px;
    }
  }
`;
